import { Menu, chakra, defineRecipe } from '@plurall/elo-v3';

const helpMenuContentRecipe = defineRecipe({
  className: 'help-menu__content',
  base: {
    borderRadius: 'shape.16',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.secondary',
    background: 'background.primary',
    boxShadow: 'var(--shadow-md, 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1))',
  },
});

const helpMenuCardRecipe = defineRecipe({
  className: 'help-menu__card',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    minWidth: 0,
    outline: 'none',
  },
});

const helpMenuItemRecipe = defineRecipe({
  className: 'help-menu__item',
  base: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    gap: 'space.8',
    padding: 'space.8',
    height: 'size.40',
    width: '100%',
    textAlign: 'start',
    fontSize: 'sm',
    fontWeight: 'normal',
    color: 'text.primary',
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    borderRadius: '8px',
    transition: 'background-color 150ms ease-in-out, color 150ms ease-in-out',
    _hover: { background: 'alpha.teal.16' },
    '&[data-highlighted]': {
      background: 'alpha.teal.16',
    },
    _focusVisible: {
      outline: '2px solid',
      outlineColor: 'action.focus.ring.primary',
      outlineOffset: '2px',
      background: 'alpha.teal.16',
    },
  },
});

// ─── Factories ────────────────────────────────────────────────────────────────

export const HelpMenuContentFactory = chakra(Menu.Content, helpMenuContentRecipe);
export const HelpMenuCardFactory = chakra('div', helpMenuCardRecipe);
export const HelpMenuItemFactory = chakra(Menu.Item, helpMenuItemRecipe);
